/**
 * Limpia un input y guarda el valor anterior
 * @param inputField
 */
export function limpiarInput(inputField) {
    const $inputField = $(inputField);
    const unidades    = $inputField.data('unidades');
    const valorActual = $inputField.val();

    if (unidades) {
        // Guardar el valor anterior en caso de selector de cajas/paquetes
        const valorAnterior = parseInt(valorActual.split('-')[0].trim(), 10);
        $inputField.data('previousValue', valorAnterior);
    } else {
        // Guardar el valor anterior para inputs simples
        $inputField.data('previousValue', valorActual);
    }

    // Vaciar el campo
    $inputField.val('');
}

export function updateCantidadFromSelect(selectElement, articuloId) {
    const $select       = $(selectElement);
    const $input        = $select.next('input[type="text"]');
    const selectedValue = $select.val();

    if (selectedValue) {
        $input.val(selectedValue);
        // Ejecutar la lógica de negocio
        if (typeof procesaSelectCantidad === 'function') {
            procesaSelectCantidad($input[0]);
        } else if (window.procesaSelectCantidad) {
            window.procesaSelectCantidad($input[0]);
        }
        // Reinicia el valor del select a la opción por defecto
        $select.find('option:first').prop('selected', true).trigger('change');
    }
}

/**
 * Comprueba y actualiza la cantidad de un artículo en la minificha
 *
 * @param inputField {HTMLElement} Campo de cantidad
 * @param articulo_id {int} ID del artículo
 *
 * @disclaimer Esta función debería estar en un script exclusivo para el input de cantidad
 */
export function updateCantidadInput(inputField, articulo_id) {
    const $inputField   = $(inputField);
    const unidades      = $inputField.data('unidades');
    let cantidad        = $inputField.val().trim();
    const previousValue = $inputField.data('previousValue');

    if (unidades) {
        // Caso selector de cajas/paquetes
        cantidad = parseInt(cantidad.split('-')[0].trim(), 10);
    }
    // Validar si el valor es un número entero positivo
    if (!/^\d+$/.test(cantidad) || parseInt(cantidad, 10) <= 0) {
        // Restaurar el valor anterior si existe, o establecer un valor por defecto
        cantidad = previousValue || (unidades ? `1 - ${unidades}` : '1');
        $inputField.val(cantidad);
    } else {
        // Actualizar el valor anterior con el valor válido actual
        $inputField.data('previousValue', cantidad);
    }
    if (cantidad > maxCantidadArticuloPedir) {
        cantidad = maxCantidadArticuloPedir;
        pNotifyWarning(transCantidadMaximaArticuloPedir);
    }
    if (unidades) {
        // Caso selector de cajas/paquetes
        $inputField.val(!isNaN(cantidad) ? `${cantidad} - ${cantidad * unidades}` : `1 - ${unidades}`);
    } else {
        // Caso input de cantidades simples
        $inputField.val(!isNaN(cantidad) && cantidad >= 0 ? cantidad : 1);
    }
    if (articulo_id) {
        $(`#product-id-${articulo_id} .btn-buy`).each(function () {
            let $button      = $(this);
            let onclickValue = $button.attr('onclick');
            if (onclickValue) {
                let updatedOnclick = onclickValue.replace(/'cantidad': \d+/, `'cantidad': ${isNaN(parseInt(cantidad)) ? 1 : parseInt(cantidad)}`);
                $button.attr('onclick', updatedOnclick);
            }
        });
    }

    return cantidad;
}

/**
 * Comprueba y actualiza la cantidad de un artículo en la minificha
 *
 * @param inputField {HTMLElement} Campo de cantidad
 *
 * @disclaimer Esta función debería estar en un script exclusivo para el input de cantidad
 */
export function updateCantidadArticuloAttachPresupuesto(inputField) {
    const $inputField   = $(inputField);
    const previousValue = $inputField.data('previousValue');
    let cantidad        = $inputField.val().trim();

    // Validar si el valor es un número entero positivo
    if (!/^\d+$/.test(cantidad) || parseInt(cantidad, 10) <= 0) {
        // Restaurar el valor anterior si existe, o establecer un valor por defecto
        cantidad = previousValue || '1';
    }

    $inputField.val(cantidad);
}

/**
 * Comprueba y actualiza la cantidad de un artículo en la minificha
 *
 * @param inputField {HTMLElement} Campo de cantidad
 *
 * @disclaimer Esta función debería estar en un script exclusivo para el input de cantidad
 */
export function updateCantidadArticuloAttachRecurso(inputField) {
    const $inputField   = $(inputField);
    const previousValue = $inputField.data('previousValue');
    let cantidad        = $inputField.val().trim();

    // Validar si el valor es un número entero positivo
    if (!/^\d+$/.test(cantidad) || parseInt(cantidad, 10) <= 0) {
        // Restaurar el valor anterior si existe, o establecer un valor por defecto
        cantidad = previousValue || '1';
    }

    $inputField.val(cantidad);
}

/**
 * Incrementa o decrementa la cantidad del input de un artículo según los botones de incremento y decremento
 *
 * @param obj {HTMLElement} Botón de incremento o decremento
 * @param increment {int} Incremento o decremento de la cantidad
 *
 * @param articuloId
 * @disclaimer Esta función debería estar en un script exclusivo para el input de cantidad
 */
export function changeCantidad(obj, increment, articuloId = null) {
    let $inputField  = $(obj).siblings('input[type="text"]');
    let currentValue = parseInt($inputField.val().trim(), 10) || 0;

    if (currentValue + increment > 0) {
        let newValue = currentValue + increment;
        if (newValue > maxCantidadArticuloPedir) {
            newValue = maxCantidadArticuloPedir;
        }
        if (newValue > 0) {
            $inputField.val(newValue);
            updateCantidad($inputField[0], articuloId);
        }
    }
}

/**
 * Incrementa o decrementa la cantidad del input de un artículo según los botones de incremento y decremento
 *
 * @param obj {HTMLElement} Botón de incremento o decremento
 * @param increment {int} Incremento o decremento de la cantidad
 *
 * @disclaimer Esta función debería estar en un script exclusivo para el input de cantidad
 */
export function changeCantidadMultiSelector(obj, increment) {
    let $inputField  = $(obj).siblings('input[type="text"]');
    let currentValue = parseInt($inputField.val().trim(), 10) || 0;

    if (currentValue + increment > 0) {
        $inputField.val(currentValue + increment);
        $inputField.trigger('input');
    }
}

/**
 * Sincroniza el select con el valor del input.
 */
export function syncSelectWithInput(inputElement) {
    const $input  = $(inputElement);
    const $select = $input.siblings('select');
    const value   = $input.val();
    if ($select.find(`option[value="${value}"]`).length > 0) {
        $select.val(value);
    } else {
        $select.val('');
    }
}

/**
 * Sincroniza el select con el input y ejecuta procesaSelectCantidad.
 */
export function handleInputCantidadEvent(inputElement) {
    syncSelectWithInput(inputElement);
    if (typeof procesaSelectCantidad === 'function') {
        procesaSelectCantidad(inputElement);
    } else if (window.procesaSelectCantidad) {
        window.procesaSelectCantidad(inputElement);
    }
}
